import React from 'react';
import DevelopersSearchPage from './DevelopersSearchPage';
import Navigation from 'components/navigation';
import { noop } from 'lodash';
import { HeaderWrapper } from 'ds/components/Layout';

const DeveloperSearchWithHeader: React.FC = () => {
  return (
    <>
      <HeaderWrapper>
        <Navigation
          isMobileMapViewActive={false}
          setMobileMapViewActive={noop}
        />
      </HeaderWrapper>
      <DevelopersSearchPage />
    </>
  );
};

export default DeveloperSearchWithHeader;
